const ApiUrl = "https://masspayments.shrinebasilicabangalore.org/api";
export default ApiUrl;
